// src/locales/si/messageCenterShiftLeaderCommission.js
export const messageCenterShiftLeaderCommission = {
  configureButton: 'නායක කොමිසම',
  modalTitle: 'මුර නායක කොමිස් සැකසුම්',
  enabled: 'මුර නායක කොමිසම සක්‍රීය කරන්න',
  calculationMethod: 'ගණන් කිරීමේ ක්‍රමය',
  perSalesValue: 'විකුණුම් අගය අනුව',
  otherMethodsComingSoon: 'ඇණවුම් අනුව සහ අයිතම අනුව ගණන් කිරීමේ ක්‍රම ඉක්මනින්.',
  calculationBase: 'ගණන් කිරීමේ පදනම',
  phaseCount: 'අදියර ගණන',
  phase: 'අදියර',
  addTier: 'ස්ලැබ් එකතු කරන්න',
  fixedAmount: 'නියත මුදල',
  targetValue: 'ඉලක්ක අගය',
  shifts: 'මුර',
  orders: 'ඇණවුම්',
  products: 'නිෂ්පාදන',
  progress: 'ප්‍රගතිය',
  saveSuccess: 'මුර නායක කොමිස් සැකසුම් සාර්ථකව සුරකින ලදී',
  saveFailed: 'මුර නායක කොමිස් සැකසුම් සුරැකීමට අසමත් විය',
  viewPageTitle: 'මුර නායක කොමිසම',
  viewPageDescription: 'මුර නායකයින් සඳහා අදියර මත පදනම් වූ කොමිස් වර්ගීකරණය, තීරණ මාසය අනුව',
  monthTotal: 'මාසික එකතුව',
  grandTotal: 'මුළු එකතුව',
  featureDisabled: 'මෙම ව්‍යාපාරය සඳහා මුර නායක කොමිසම සක්‍රීය කර නොමැත',
  noLeadersForMonth: 'මෙම මාසයේ කිසිදු මුර නායකයෙකු මුරයක් මෙහෙයවා නොමැත',
  failedToLoadReport: 'මුර නායක කොමිස් වාර්තාව පූරණය කිරීමට අසමත් විය',
  enabledHelp: 'When off, leaders earn no phase commission. Any tiers entered are still validated.',
  phaseCountPlaceholder: 'e.g. 3',
  targetValuePlaceholder: 'e.g. 5500000',
  validation: {
    targetNegative: 'Target value cannot be negative',
    minValueInvalid: 'සෑම ස්ලැබ් එකකටම වලංගු, සෘණ නොවන අවම අගයක් අවශ්‍යයි',
    maxValueRequired: 'අවසාන ස්ලැබ් හැර සෑම ස්ලැබ් එකකටම උපරිම අගය අවශ්‍යයි',
    rateInvalid: 'සෑම ස්ලැබ් එකකටම වලංගු, සෘණ නොවන අනුපාතයක් අවශ්‍යයි',
    fixedAmountInvalid: 'සෑම ස්ලැබ් එකකටම වලංගු, සෘණ නොවන නියත මුදලක් අවශ්‍යයි',
  },
};
